import { HdBodygraphPlanetaryActivation, HdBodygraphRenderState } from '../hd-bodygraph.models';
import { HD_BODYGRAPH_GATE_TO_CENTER } from '../hd-bodygraph-metadata';
import { getHdPlanetDisplayConfigByPlanetId } from '../planet-grid/hd-planet-display-config';
import { HdGateBlockCluster, HdGateBlockDescriptor } from './hd-gate-block.models';

/**
 * Activaties → blok-descriptors (spec §4). De activaties komen al side-
 * gefilterd binnen (`displayPlanetaryActivations` op de page), dus hier geen
 * sideMode-logica. Activaties zonder planeet-config of buiten de 64 poorten
 * worden stil overgeslagen.
 */
export function buildHdGateBlockDescriptors(
  activations: readonly HdBodygraphPlanetaryActivation[],
  renderState: HdBodygraphRenderState,
): HdGateBlockDescriptor[] {
  const descriptors: HdGateBlockDescriptor[] = [];
  for (const activation of activations) {
    if (activation.side !== 'design' && activation.side !== 'personality') {
      continue;
    }
    const config = getHdPlanetDisplayConfigByPlanetId(activation.planetId);
    const center = HD_BODYGRAPH_GATE_TO_CENTER[activation.gate];
    if (!config || !center) {
      continue;
    }
    descriptors.push({
      gate: activation.gate,
      planetId: activation.planetId,
      side: activation.side,
      isDefined: renderState.centerStates[center]?.isDefined ?? false,
      glyph: config.astronomiconChar,
    });
  }
  return descriptors;
}

function sideRank(side: HdGateBlockDescriptor['side']): number {
  return side === 'design' ? 0 : 1;
}

/** Vaste sortering (spec §3): design vóór personality, daarbinnen planetId. */
function compareBlocks(a: HdGateBlockDescriptor, b: HdGateBlockDescriptor): number {
  return sideRank(a.side) - sideRank(b.side) || a.planetId - b.planetId;
}

export function buildHdGateBlockClusters(
  descriptors: readonly HdGateBlockDescriptor[],
): HdGateBlockCluster[] {
  const byGate = new Map<number, HdGateBlockDescriptor[]>();
  for (const descriptor of descriptors) {
    const list = byGate.get(descriptor.gate) ?? [];
    list.push(descriptor);
    byGate.set(descriptor.gate, list);
  }
  return [...byGate.entries()]
    .sort((a, b) => a[0] - b[0])
    .map(([gate, blocks]) => ({ gate, blocks: [...blocks].sort(compareBlocks) }));
}
